import { render, staticRenderFns } from "./Findpsw.vue?vue&type=template&id=6f770de4&scoped=true"
import script from "./Findpsw.vue?vue&type=script&lang=js"
export * from "./Findpsw.vue?vue&type=script&lang=js"
import style0 from "./Findpsw.vue?vue&type=style&index=0&id=6f770de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f770de4",
  null
  
)

export default component.exports